(function () {
  function toggleButton(btn, available) {
    if (!btn) return;
    btn.classList.toggle('sc-notify-me-btn--visible', available === false);
  }

  function initTrigger(container) {
    var btn = container.querySelector('[data-sc-notify-me-trigger]');
    if (!btn || btn.dataset.scNotifyInitialized === 'true') return;
    btn.dataset.scNotifyInitialized = 'true';

    container.addEventListener('variantChange', function (evt) {
      var variant = evt.detail.variant;
      toggleButton(btn, variant ? variant.available : false);
    });
  }

  function initModal(modalEl) {
    if (!modalEl || modalEl.dataset.scNotifyModalInitialized === 'true') return;
    if (typeof theme === 'undefined' || !theme.Modals) return;
    modalEl.dataset.scNotifyModalInitialized = 'true';

    var instance = new theme.Modals(modalEl.id, modalEl.dataset.modalName);

    if (modalEl.dataset.shouldOpen === 'true') {
      instance.open();
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-type="product"]').forEach(initTrigger);
    (scope || document).querySelectorAll('[id^="NotifyMeModal-"]').forEach(initModal);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });
})();
